import { yup } from '@guiker/shared-framework'

const assetSchema = yup.object({ id: yup.string().required() })
const assetsSchema = yup.array().of(assetSchema)

export const updatePropRentalAgreementSchema = yup.object<{
  contractId?: string
  assets?: { id: string }[]
  onboarding?: {
    started?: string
    expired?: string
  }
}>({
  contractId: yup.string().nullable(),
  assets: assetsSchema,
  onboarding: yup.object({
    started: yup.string().nullable(),
    expired: yup.string().nullable(),
  }),
})
